/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

const SIZES = { small: 16, medium: 24, large: 32, xlarge: 48 } as const;

export interface IconProps {
	size?: keyof typeof SIZES;
	label?: string;
	testId?: string;
}

const containerStyles = css({ display: 'inline-block', flexShrink: 0 });
const svgStyles = css({
	maxWidth: '100%',
	maxHeight: '100%',
	pointerEvents: 'none',
	verticalAlign: 'bottom',
});

/**
 * __ThemeIcon__
 */
const ThemeIcon = ({ size = 'medium', label, testId }: IconProps): React.JSX.Element => {
	const dimension = SIZES[size];
	return (
		<span
			role={label ? 'img' : undefined}
			aria-label={label || undefined}
			aria-hidden={label ? undefined : true}
			data-testid={testId}
			css={containerStyles}
		>
			<svg
				width={dimension}
				height={dimension}
				viewBox="0 0 24 24"
				focusable="false"
				xmlns="http://www.w3.org/2000/svg"
				css={svgStyles}
			>
				<path
					fill="currentColor"
					d="M12 2c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10m0 2v16c-4.4 0-8-3.6-8-8s3.6-8 8-8"
				/>
			</svg>
		</span>
	);
};

export default ThemeIcon;
